export default "__VITE_PUBLIC_ASSET__5dcced00__"